module.exports = __webpack_public_path__ + "static/media/201EC216.cc3a980d.jpg";